"use strict";

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledErrorMessage = exports.StyledTextArea = exports.StyledTextAreaContainer = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _colors = require("../../utils/colors");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  font-size: ", ";\n  color: ", ";\n  padding: 0 0.5rem;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: 1rem;\n  color: ", ";\n  padding: 0.5em;\n  width: ", ";\n  background: transparent;\n  ", ";\n  ", ";\n  ", ";\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    border: none;\n    border-bottom: 1px solid\n      ", ";\n    :focus {\n      outline: none;\n      border-bottom: 1px solid ", ";\n      background: ", ";\n    }\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    opacity: 0.3;\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    ::placeholder {\n      color: ", ";\n      opacity: 1; // for firefox\n    }\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var placeholderStyle = function placeholderStyle() {
  return (0, _styledComponents.css)(_templateObject(), function (props) {
    return (0, _colors.getRGBOpacity)((0, _colors.normaliseColor)(props.theme.textField.textColor, props.theme), 0.3);
  });
};

var disabledStyle = function disabledStyle() {
  return (0, _styledComponents.css)(_templateObject2());
};

var borderStyle = function borderStyle(props) {
  return (0, _styledComponents.css)(_templateObject3(), function () {
    return props.error ? props.theme.colors.error300 : (0, _colors.normaliseColor)(props.theme.textField.border.color, props.theme);
  }, (0, _colors.normaliseColor)(props.theme.textField.border.focusColor, props.theme), (0, _colors.getRGBOpacity)(props.theme.colors.actionPrimary300, 0.1));
};

var StyledTextAreaContainer = _styledComponents.default.div(_templateObject4());

exports.StyledTextAreaContainer = StyledTextAreaContainer;

var StyledTextArea = _styledComponents.default.textarea.attrs({
  type: 'text'
})(_templateObject5(), function (props) {
  return props.theme.defaultFontFamily;
}, function (props) {
  return (0, _colors.normaliseColor)(props.theme.textField.textColor, props.theme);
}, function (props) {
  return props.width;
}, borderStyle, placeholderStyle, function (props) {
  return props.disabled && disabledStyle;
});

exports.StyledTextArea = StyledTextArea;

var StyledErrorMessage = _styledComponents.default.div(_templateObject6(), function (props) {
  return props.theme.typography.text.small.fontSize.xs;
}, function (props) {
  return props.theme.colors.error300;
});

exports.StyledErrorMessage = StyledErrorMessage;